<mat-toolbar class="pc-header " [ngStyle]="{
  backgroundColor: '#1e88e5 !important'
}">
  <div class="header-wrapper ">
    <app-nav-left></app-nav-left>
    <app-nav-right></app-nav-right>
  </div>
</mat-toolbar>
